import {TimeFormat} from '@hconnect/common/components'
import {DateRange, RunningTimeDto, TimeZone} from '@hconnect/common/types'
import {DateFormat} from '@hconnect/uikit'
import {Box, Typography} from '@mui/material'
import {last} from 'lodash'
import {FC, RefObject, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type StoppageAnalysisGraphLabelsProps = {
  timeRange: DateRange
  timezone: TimeZone
  overflowsStartDate: boolean
  overflowsEndDate: boolean
  equipmentRunningTimes?: RunningTimeDto[]
  startDateRef?: RefObject<HTMLDivElement | undefined>
  endDateRef?: RefObject<HTMLDivElement | undefined>
}

export const StoppageAnalysisGraphLabels: FC<StoppageAnalysisGraphLabelsProps> = ({
  timeRange,
  timezone,
  startDateRef,
  endDateRef,
  overflowsStartDate,
  overflowsEndDate,
  equipmentRunningTimes
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const isDateSame = timeRange.startDate.isSame(timeRange.endDate, 'day')

  const lastRunningTimeEndTime = useMemo(() => {
    if (overflowsStartDate || overflowsEndDate) {
      return last(equipmentRunningTimes)?.end
    }
  }, [equipmentRunningTimes, overflowsEndDate, overflowsStartDate])

  return (
    <Box
      sx={{
        flex: '1',
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        borderRadius: 1,
        overflow: 'hidden'
      }}
    >
      <Box display="flex" mb={1}>
        <Box component={Typography} variant="caption" pr={1} ref={startDateRef}>
          {!isDateSame && (
            <>
              <DateFormat date={timeRange.startDate.toISOString()} timezone={timezone} /> -{' '}
            </>
          )}
          <TimeFormat date={timeRange.startDate.toISOString()} timezone={timezone} />
        </Box>
        {overflowsStartDate && lastRunningTimeEndTime && (
          <Box component={Typography} fontWeight={600} fontSize={12} lineHeight="16px">
            {t('stoppageAnalysisGraph.label.now')},{' '}
            <TimeFormat date={lastRunningTimeEndTime} timezone={timezone} />
          </Box>
        )}
      </Box>
      <Box display="flex" mb={1}>
        {overflowsEndDate && lastRunningTimeEndTime && (
          <Box component={Typography} fontWeight={600} fontSize={12} lineHeight="16px">
            {t('stoppageAnalysisGraph.label.now')},{' '}
            <TimeFormat date={lastRunningTimeEndTime} timezone={timezone} />
          </Box>
        )}
        <Box component={Typography} variant="caption" pl={1} ref={endDateRef}>
          {!isDateSame && (
            <>
              <DateFormat date={timeRange.endDate.toISOString()} timezone={timezone} /> -{' '}
            </>
          )}
          <TimeFormat date={timeRange.endDate.toISOString()} timezone={timezone} />
        </Box>
      </Box>
    </Box>
  )
}
